import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["blendCheckbox", "selectAllCheckbox", "createBatchButton"]

  connect() {
    this.updateButton()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.blendCheckboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateButton()
  }

  updateButton() {
    const anyChecked = this.blendCheckboxTargets.some(checkbox => checkbox.checked)
    this.createBatchButtonTarget.disabled = !anyChecked

    if (this.hasSelectAllCheckboxTarget) {
      const allChecked = this.blendCheckboxTargets.length > 0 &&
                        this.blendCheckboxTargets.every(checkbox => checkbox.checked)
      const someChecked = this.blendCheckboxTargets.some(checkbox => checkbox.checked)

      this.selectAllCheckboxTarget.checked = allChecked
      this.selectAllCheckboxTarget.indeterminate = someChecked && !allChecked
    }
  }

  createBatch() {
    const selectedBlendIds = this.blendCheckboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.dataset.blendId)

    if (selectedBlendIds.length === 0) {
      return
    }

    const url = new URL('/crafting/object_batches/new?object_type=blend', window.location.origin)
    url.searchParams.append('blend_ids', selectedBlendIds.join(','))
    window.location.href = url.toString()
  }
}
